import { render } from "./wysiwyg-preview.vue?vue&type=template&id=79bccef6&scoped=true"
import script from "./wysiwyg-preview.vue?vue&type=script&lang=js"
export * from "./wysiwyg-preview.vue?vue&type=script&lang=js"

import "./wysiwyg-preview.vue?vue&type=style&index=0&id=79bccef6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-79bccef6"

export default script